import IBAN from 'iban'

// letters: accents allowed, but not on uppercase letters,
// numbers, -, space
function validCharacters (v) {
  return /(^[A-Za-zà-öø-ÿ0-9\- ]+$)/g.test(v)
}
// letters only, accents allowed, space
function validCharactersForNames (v) {
  return /(^[a-zA-Z0-9+'\- ]+$)/g.test(v)
}
// letters + numbers, no accents allowed, space, &, -
function validCharactersForEnterprise (v) {
  return /(^[A-Za-z0-9&\- ]+$)/g.test(v)
}
// letters: accents allowed, but not on uppercase letters, space, -
function validCharactersForCity (v) {
  return /(^[A-Za-zà-öø-ÿ\- ]+$)/g.test(v)
}
// letters: accents allowed, but not on uppercase letters,
// numbers, -, space, .
function validCharactersForAlias (v) {
  return /(^[A-Za-zà-öø-ÿ0-9\- .]+$)/g.test(v)
}

export default {
  data: function () {
    return {
      rules: {
        iban: [
          v => !!v || this.$t('validation_iban'),
          v => !!IBAN.isValid(v) || this.$t('validation_iban_2')
        ],
        bic: [
          v => !!v || this.$t('validation_bic')
        ],
        name: [
          v => !!v || this.$t('validation_name'),
          v => !!(v.replace(/\s/g, '')) || this.$t('validation_name'),
          v => validCharactersForNames(v) || this.$t('validation_name_invalid'),
          v => (!v || v.length < 39) || this.$t('validation_38_length')
        ],
        address: [
          v => !!v || this.$t('validation_address'),
          v => validCharacters(v) || this.$t('validation_address_invalid'),
          v => (!v || v.length < 39) || this.$t('validation_38_length')
        ],
        address_optional: [
          v => (!v || validCharacters(v)) || this.$t('validation_address_invalid'),
          v => (!v || v.length < 39) || this.$t('validation_38_length')
        ],
        enterprise: [
          v => !!v || this.$t('validation_enterprise_empty'),
          v => (!v || validCharactersForEnterprise(v)) || this.$t('validation_enterprise'),
          v => (!v || v.length < 51) || this.$t('validation_50_length')
        ],
        enterprise_optional: [
          v => (!v || validCharactersForEnterprise(v)) || this.$t('validation_enterprise'),
          v => (!v || v.length < 51) || this.$t('validation_50_length')
        ],
        // postalCode: [
        //   v => !!v || this.$t('validation_postalCode')
        // ],
        city: [
          v => !!v || this.$t('validation_city'),
          v => validCharactersForCity(v) || this.$t('validation_city_invalid'),
          v => (!v || v.length < 51) || this.$t('validation_50_length')
        ],
        country: [
          v => !!v || this.$t('validation_country')
        ],
        province: [
          v => !!v || this.$t('validation_province')
        ],
        email: [
          v => !!v || this.$t('validation_email'),
          v => /^[^ ]+@[-a-zA-Z0-9_]+?.[a-zA-Z]{2,3}$/.test(v) || this.$t('validation_email_2'),
          v => (!v || v.length < 51) || this.$t('validation_50_length')
        ],
        aliasLabel: [
          v => !!v || this.$t('validation_aliasLabel'),
          v => (validCharactersForAlias(v)) || this.$t('validation_aliasLabel'),
          v => (v.length < 51) || this.$t('validation_50_length')
        ],
        aliasLabel_optional: [
          v => (!v || validCharactersForAlias(v)) || this.$t('validation_aliasLabel'),
          v => (!v || v.length < 51) || this.$t('validation_50_length')
        ],
      //   phone: [
      //     v => !!v || this.$t('validation_phone'),
      //     v => !!Number.parseInt(v) || this.$t('validation_phone2')
      //   ],
      //   phoneOptional: [
      //     v => !v || !!Number.parseInt(v) || this.$t('validation_phone2')
      //   ] 
      }
    }
  }
}
